/*global ace */

ace.define("ace/mode/version_highlight_rules",["require","exports","module","ace/lib/oop","ace/mode/text_highlight_rules"], function(require, exports, module) {
  "use strict";

  var oop = require("../lib/oop");
  var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;

  var escapeRe = "\\\\(?:[\\\\0abtrn;#=:]|x[a-fA-F\\d]{4})";

  var VersionHighlightRules = function() {
    this.$rules = {
      start: [{
        token: "keyword.version",
        regex: "\\d+(\\.\\d+)+"
      }, {
        token: "keyword.tag",
        regex: "-.*"
      }]
    };

    this.normalizeRules();
  };

  oop.inherits(VersionHighlightRules, TextHighlightRules);

  exports.VersionHighlightRules = VersionHighlightRules;
});

ace.define("ace/mode/version",
        ["require","exports","module","ace/lib/oop","ace/mode/text","ace/mode/version_highlight_rules"],
        function(require, exports) {
  "use strict";

  var oop = require("../lib/oop");
  var TextMode = require("./text").Mode;
  var VersionHighlightRules = require("./version_highlight_rules").VersionHighlightRules;

  var Mode = function() {
    this.HighlightRules = VersionHighlightRules;
  };
  oop.inherits(Mode, TextMode);

  (function() {
    this.$id = "ace/mode/version";
  }).call(Mode.prototype);

  exports.Mode = Mode;
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/channels/mode-version.js
// module id = 511
// module chunks = 1